import { Injectable, TemplateRef } from '@angular/core';
import { ModalComponent, ModalProps } from '../common/components/modal/modal.component';
import { ButtonVariant, IButtonProps } from '@amobee/component-library';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    private _modal: ModalComponent;
    private defualtModalProps: ModalProps;

    set modal(modal: ModalComponent) {
        this._modal = modal;
        this.defualtModalProps = modal.modalProps;
    }

    // return close modal method to provide a way to dismiss the modal in case of no button or disabled close on click outside
    openModal(modalProps: ModalProps): (isClickOnOutside?: boolean) => void {
        this._modal.modalProps = Object.assign({}, this.defualtModalProps, modalProps);
        this._modal.openModal();
        return this._modal.closeModal.bind(this._modal);
    }

    confirmation(bodyContent: { message: string; subMessage?: string } | TemplateRef<any> | any, headerContent?: string, confirmLabel?: string, confirmCallBack?: () => void, cancelCallBack?: () => void, footerContent?: Array<IButtonProps>, nonFooterClickCallabck?: () => void) {
        if (bodyContent.message && !bodyContent.subMessage) {
            bodyContent.subMessage = 'Click Confirm to continue, or click Cancel to stay on this page.';
        }
        if (!_.size(footerContent)) {
            footerContent = [
                {
                    label: confirmLabel || 'Confirm',
                    variant: ButtonVariant.PRIMARY,
                    onClick: () => {
                        if (confirmCallBack) {
                            confirmCallBack();
                        }
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                        if (cancelCallBack) {
                            cancelCallBack();
                        }
                    }
                }
            ]
        }
        this.openModal({
            closeButton: true,
            headerContent: headerContent || 'Confirmation',
            bodyContent: bodyContent,
            footerContent: footerContent,
            onNonFooterClick: nonFooterClickCallabck
        });
    }

    info(bodyContent: { message: string; subMessage?: string }) {
        this.openModal({
            headerContent: 'Information',
            bodyContent: bodyContent,
        });
    }

    error(bodyContent: { message: string; subMessage?: string }) {
        this.openModal({
            headerContent: 'Error',
            bodyContent: bodyContent,
        });
    }
}